<template>
  <div class="new-dispatch-modal">
    <!-- Filters -->
    <div class="form-grid">
      <div class="form-group">
        <label>From Date <span>*</span></label>
        <input type="date" v-model="startDate" class="search-input" @change="handleDateChange" :max="currentDate" />
      </div>

      <div class="form-group">
        <label>To Date <span>*</span></label>
        <input type="date" v-model="endDate" class="search-input" @change="handleDateChange" :max="currentDate" />
      </div>

      <div class="form-group">
        <label>Distributor <span>*</span></label>
        <select v-model="selectedDistributor" @change="onDistributorChange"
          :disabled="isDistributorLocked || isLoading">
          <option disabled value="">Select Distributor</option>

          <option v-if="!isDistributorUser" :value="ALL">All Distributors</option>

          <option v-for="d in distributorList" :key="d.profile_id" :value="String(d.profile_id)">
            {{ d.name }}
          </option>
        </select>

      </div>
    </div>

    <div class="form-grid">
      <div class="form-group">
        <label>Sales Rep</label>
        <select v-model="selectedSalesRep">
          <option value="">All</option>
          <option v-for="rep in salesRepList" :key="rep.profile_id" :value="String(rep.profile_id)">
            {{ rep.name }}
          </option>

        </select>
      </div>

      <div class="form-group">
        <label>Route</label>
        <select v-model="selectedSalesRoute">
          <option value="">All</option>
          <option v-for="r in salesRouteList" :key="r.route_id" :value="r.route_id">
            {{ r.route_name }}
          </option>
        </select>
      </div>

      <div class="form-group search">
        <button @click="performSearch" class="btn button-default">Search</button>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="isLoading" class="loading-spinner text-center">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>


    <!-- Download Floating Button -->
    <button v-if="filteredInvoices.length" @click="exportToExcel" class="download-button">
      <i class="fa-solid fa-download"></i>
      <span class="tooltip-text">Download</span>
    </button>

    <!-- Report Table -->
    <div v-if="!isLoading && searchedOnce && filteredInvoices.length > 0" id="printableReport">
      <div class="table-container">
        <table class="table table-responsive-sm">
          <thead>
            <tr>
              <th>DEALER NAME</th>
              <th>INVOICE NO</th>
			  <th>INVOICE DATE</th>
              <th v-for="itemType in itemTypes" :key="itemType">
                {{ itemType }}
              </th>
              <th>NET TOTAL</th>
              <th>VAT AMOUNT</th>
              <th>GROSS TOTAL</th>
              <th>CASH AMOUNT</th>
              <th>CHEQUE AMOUNT</th>
              <th>BANK TRANSFER AMOUNT</th>
              <th>CREDIT AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, idx) in filteredInvoices" :key="idx">
              <td>{{ invoice.dealer_name || "N/A" }}</td>
			  <td>{{ invoice.invoice_no || "-" }}</td>
			  <td>{{ invoice.invoice_date || "-" }}</td>              

              <!-- Render item columns dynamically -->
              <td v-for="itemType in itemTypes" :key="itemType">
                {{
                  getQuantityForItem(invoice.items, itemType)
                }}
              </td>

                <td>{{ formatAmount(invoice.net_total) }}</td>
                <td>{{ invoice.vat_liable === "1" ? formatAmount(invoice.vat_amount) : "0.00" }}</td>
                <td>{{ formatAmount(invoice.gross_total) }}</td>

                <td>{{ formatAmount(invoice.cash_amount) }}</td>
                <td>{{ formatAmount(invoice.cheque_amount) }}</td>
                <td>{{ formatAmount(invoice.bank_transfer_amount) }}</td>
                <td>{{ formatAmount(invoice.credit_amount) }}</td>
            </tr>

            <!-- Totals -->
              <tr>
              <td><strong>TOTAL</strong></td>
              <td></td>          <!-- INVOICE NO -->
              <td></td>          <!-- INVOICE DATE  ← add this -->
              <td v-for="itemType in itemTypes" :key="itemType">
              <strong>{{ getTotalForItemType(itemType) }}</strong>
              </td>
              <td><strong>{{ formatAmount(totalNetAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalVatAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalGrossAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalCashAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalChequeAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalBankTransferAmount) }}</strong></td>
              <td><strong>{{ formatAmount(totalCreditAmount) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else-if="!isLoading && !searchedOnce" class="no-invoices-message text-center">
      Please select filters and click Search.
    </div>

    <div v-else-if="!isLoading && searchedOnce" class="no-invoices-message text-center">
      No Invoices Found.
    </div>

  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as XLSX from "xlsx";
import { useRouter } from "vue-router";
import {
  fetchDistributorsList,
  fetchInvoiceSummary,
  fetchRepListInvoice,
  fetchSalesRoute,
} from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    const currentDate = new Date().toLocaleDateString("en-CA");
    return {
      token: localStorage.getItem("token_set"),
      profile_id: localStorage.getItem("profile_id") || null,
      selectedDistributor: "",
      selectedSalesRep: "",
      selectedSalesRoute: "",
      distributorList: [],
      salesRepList: [],
      salesRouteList: [],
      startDate: currentDate,
      endDate: currentDate,
      currentDate: currentDate,
      filteredInvoices: [],
      itemTypes: [],
      loading: false,

      ALL: "__all__",
      userLabel: "",
      roleKey: "OTHER",
      myProfileId: Number(localStorage.getItem("profile_id") || 0),
      isDistributorLocked: false,
      loadingInit: false,
      searchedOnce: false,
    };
  },

  setup() {
    const router = useRouter();
    return { router };
  },

  computed: {
  totalGrossAmount() {
    return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.gross_total), 0);
  },
  totalVatAmount() {
  return this.filteredInvoices.reduce((t, inv) => {
    return t + (inv.vat_liable === "1" ? this.toNumber(inv.vat_amount) : 0);
  }, 0);
},
  totalNetAmount() {
    return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.net_total), 0);
  },
    totalCashAmount() 
    {
      return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.cash_amount), 0);
    },
    totalChequeAmount() {
      return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.cheque_amount), 0);
    },
    totalBankTransferAmount() {
      return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.bank_transfer_amount), 0);
    },
    totalCreditAmount() {
      return this.filteredInvoices.reduce((t, inv) => t + this.toNumber(inv.credit_amount), 0);
    },
    totalOverallAmount() {
      return (
        this.totalCashAmount +
        this.totalChequeAmount +
        this.totalBankTransferAmount +
        this.totalCreditAmount
      );
    },

    isDistributorUser() { return this.roleKey === "DIS"; },

    isLoading() { return this.loadingInit || this.loading; },

  },

  // created() {
  //   this.loadDistributorList();
  //   this.loadRouteList();
  // },

  created() {
    this.initRoleFromStorage();
    this.initPage();
  },


  methods: {
    toNumber(value) {
      return parseFloat(String(value || "0").replace(/,/g, "")) || 0;
    },
    formatAmount(value) {
      return this.toNumber(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },


    initRoleFromStorage() {
      const labelFromStorage =
        localStorage.getItem("user_label") ||
        localStorage.getItem("userLabel") ||
        localStorage.getItem("role") ||
        "";

      this.userLabel = String(labelFromStorage || "");
      const u = this.userLabel.toUpperCase().trim();

      if (u === "DISTRIBUTOR" || u.startsWith("DISTRIBUTOR") || u === "DIS" || u.startsWith("DIS_")) this.roleKey = "DIS";
      else if (u === "ASM" || u.startsWith("ASM_")) this.roleKey = "ASM";
      else if (u === "FSM" || u.startsWith("FSM_")) this.roleKey = "FSM";
      else this.roleKey = "OTHER";

      this.myProfileId = Number(localStorage.getItem("profile_id") || 0);
      this.isDistributorLocked = false;
    },

    async initPage() {
      this.loadingInit = true;
      try {
        // await Promise.all([this.loadDistributorList(), this.loadRouteList()]);
        await Promise.all([this.loadDistributorList()]);
      } finally {
        this.loadingInit = false;
      }
    },

    isValidISODate(dateStr) {
      if (!dateStr || typeof dateStr !== "string") return false;
      if (dateStr.includes("/")) return false;

      const m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return false;

      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);

      const dt = new Date(y, mo - 1, d);
      return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
    },

    validateStartDate(showToast = true) {
      if (!this.startDate) return true;

      if (!this.isValidISODate(this.startDate)) {
        if (showToast) this.showErrorToast("Invalid From Date");
        this.startDate = "";
        return false;
      }

      if (this.startDate > this.currentDate) {
        if (showToast) this.showErrorToast("From Date cannot be in the future");
        this.startDate = "";
        return false;
      }

      return true;
    },

    validateEndDate(showToast = true) {
      if (!this.endDate) return true;

      if (!this.isValidISODate(this.endDate)) {
        if (showToast) this.showErrorToast("Invalid To Date");
        this.endDate = "";
        return false;
      }

      if (this.endDate > this.currentDate) {
        if (showToast) this.showErrorToast("To Date cannot be in the future");
        this.endDate = "";
        return false;
      }

      return true;
    },

    validateDatesForSearch() {
      if (!this.startDate) { this.showErrorToast("Please select valid From Date"); return false; }
      if (!this.endDate) { this.showErrorToast("Please select valid To Date"); return false; }

      if (!this.validateStartDate(true)) return false;
      if (!this.validateEndDate(true)) return false;

      if (this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        return false;
      }
      return true;
    },




    getTotalAmountForInvoice(inv) {
      return (
        this.toNumber(inv.cash_amount) +
        this.toNumber(inv.cheque_amount) +
        this.toNumber(inv.bank_transfer_amount) +
        this.toNumber(inv.credit_amount)
      );
    },

    getQuantityForItem(itemsArray, itemName) {
      const item = itemsArray?.find((i) => i.item_name === itemName);
      return item ? parseFloat(item.quantity).toFixed(2) : "0.00";
    },

    getTotalForItemType(itemName) {
      return this.filteredInvoices.reduce((sum, inv) => {
        const item = inv.items?.find((i) => i.item_name === itemName);
        return sum + (item ? parseFloat(item.quantity) : 0);
      }, 0).toFixed(2);
    },

    handleDateChange() {
      this.validateStartDate(false);
      this.validateEndDate(false);

      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        this.endDate = "";
      }
    },


    showErrorToast(msg) {
      const toast = useToast();
      toast.error(msg, { position: "top-right", timeout: 3000 });
    },
    showSuccessToast(msg) {
      const toast = useToast();
      toast.success(msg, { position: "top-right", timeout: 3000 });
    },

    // async loadDistributorList() {
    //   try {
    //     const res = await fetchDistributorsList(this.profile_id, this.token);
    //     this.distributorList = res.data.data || [];
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },

    async loadDistributorList() {
      try {
        const res = await fetchDistributorsList(this.profile_id, this.token);
        let list = res?.data?.data || [];

        // reset
        this.isDistributorLocked = false;

        // ✅ Distributor login: auto pick own distributor + lock
        if (this.isDistributorUser && this.myProfileId) {
          const mine = list.find(d => Number(d.profile_id) === Number(this.myProfileId));

          if (mine) {
            // lock to own distributor
            list = [mine];
            this.selectedDistributor = String(mine.profile_id);
            this.isDistributorLocked = true;

            // ✅ load reps for this distributor (because programmatic set won't trigger @change)
            this.selectedSalesRep = "";
            this.salesRepList = [];
            await this.loadSalesRepList();


            this.selectedSalesRoute = "";
            this.salesRouteList = [];
            await this.loadRouteList(this.selectedDistributor);

          } else {
            // if not found, clear everything
            this.selectedDistributor = "";
            this.selectedSalesRep = "";
            this.salesRepList = [];
            this.isDistributorLocked = false;
            this.selectedSalesRoute = "";
            this.salesRouteList = [];

          }
        } else {
          // other users: start empty (they can pick "ALL" or a distributor manually)
          this.selectedDistributor = "";
          this.selectedSalesRep = "";
          this.salesRepList = [];
        }

        this.distributorList = list;
      } catch (err) {
        console.error(err);
        this.distributorList = [];
        this.selectedDistributor = "";
        this.selectedSalesRep = "";
        this.salesRepList = [];
        this.isDistributorLocked = false;
      }
    },



    // async onDistributorChange() {
    //   this.selectedSalesRep = "";
    //   this.salesRepList = [];

    //   if (!this.selectedDistributor) return;

    //   // ✅ ALL selected -> no reps filter
    //   if (this.selectedDistributor === this.ALL) return;

    //   await this.loadSalesRepList();
    // },




    // async loadSalesRepList() {
    //   if (!this.selectedDistributor) return;
    //   try {
    //     const res = await fetchRepListInvoice(this.selectedDistributor, this.selectedDistributor, this.token);
    //     this.salesRepList = res.data.data || [];
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },

    // async onDistributorChange() {
    //   this.selectedSalesRep = "";
    //   this.salesRepList = [];

    //   if (!this.selectedDistributor) return;
    //   if (this.selectedDistributor === this.ALL) return;

    //   await this.loadSalesRepList();
    // },


    async onDistributorChange() {
      // reset rep + route filters
      this.selectedSalesRep = "";
      this.salesRepList = [];

      this.selectedSalesRoute = "";
      this.salesRouteList = [];

      if (!this.selectedDistributor) return;

      // ALL selected -> load "general/all" routes (fallback by profile_id)
      if (this.selectedDistributor === this.ALL) {
        await this.loadRouteList(null);
        return;
      }

      // load reps + routes for selected distributor
      await Promise.all([
        this.loadSalesRepList(),
        this.loadRouteList(this.selectedDistributor),
      ]);
    },


    async loadSalesRepList() {
      this.salesRepList = [];
      this.selectedSalesRep = "";

      if (!this.selectedDistributor) return;
      if (this.selectedDistributor === this.ALL) return;

      try {
        // ✅ IMPORTANT: keep same as old working code
        const res = await fetchRepListInvoice(
          this.selectedDistributor,
          this.selectedDistributor,
          this.token
        );

        this.salesRepList = res?.data?.data || [];
      } catch (err) {
        console.error("Error loading sales reps:", err?.response?.data || err);
        this.salesRepList = [];
      }
    },




    // async loadRouteList() {
    //   try {
    //     const res = await fetchSalesRoute(this.profile_id, this.token);
    //     this.salesRouteList = res.data.data || [];
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },

    async loadRouteList(distributorId = null) {
      try {
        // ✅ if distributor selected -> use that id as profileId for API
        // ✅ if ALL / empty -> fallback to logged-in profile_id (keeps old behavior)
        const idToUse =
          distributorId && distributorId !== this.ALL
            ? distributorId
            : this.profile_id;

        const res = await fetchSalesRoute(idToUse, this.token);
        this.salesRouteList = res?.data?.data || [];
      } catch (err) {
        console.error("Error loading routes:", err?.response?.data || err);
        this.salesRouteList = [];
      }
    },


    async performSearch() {
      // reset results first (ok)
      this.filteredInvoices = [];
      this.itemTypes = [];

      // ✅ validations BEFORE enabling loader + searchedOnce
      if (!this.validateDatesForSearch()) return;

      if (!this.selectedDistributor) {
        this.showErrorToast("Please select a Distributor.");
        return;
      }

      if (this.isDistributorUser && this.selectedDistributor === this.ALL) {
        this.showErrorToast("Please select a Distributor.");
        return;
      }

      // ✅ now set flags
      this.searchedOnce = true;
      this.loading = true;


      try {
        const searchData = {
          fromDate: this.startDate,
          toDate: this.endDate,

          distributor_id: this.selectedDistributor === this.ALL ? null : this.selectedDistributor,

          Rep_id: this.selectedSalesRep,
          route_id: this.selectedSalesRoute,
        };

        const res = await fetchInvoiceSummary(searchData, this.token);
        this.filteredInvoices = res.data || [];

        // Collect all unique item names
        const itemSet = new Set();
        this.filteredInvoices.forEach((inv) => {
          inv.items?.forEach((i) => itemSet.add(i.item_name));
        });
        this.itemTypes = Array.from(itemSet);
        this.showSuccessToast("Data fetched successfully!");
      } catch (err) {
        console.error(err);
        this.showErrorToast("Failed to fetch data");
      } finally {
        this.loading = false;
      }
    },

    exportToExcel() {
      if (!this.filteredInvoices.length) {
        this.showErrorToast("No data available to export.");
        return;
      }

      const sheetData = this.filteredInvoices.map((inv) => {
        const row = {
          "Dealer Name": inv.dealer_name,
          "Invoice No": inv.invoice_no,
		  "Invoice Date": inv.invoice_date,
        };
        this.itemTypes.forEach((item) => {
          row[item] = this.getQuantityForItem(inv.items, item);
        });;
        row["Net Total"] = this.formatAmount(inv.net_total);
        row["VAT Amount"] = inv.vat_liable === "1" ? this.formatAmount(inv.vat_amount) : "0.00";
        row["Gross Total"] = this.formatAmount(inv.gross_total);
        row["Cash Amount"] = this.formatAmount(inv.cash_amount);
        row["Cheque Amount"] = this.formatAmount(inv.cheque_amount);
        row["Bank Transfer Amount"] = this.formatAmount(inv.bank_transfer_amount);
        row["Credit Amount"] = this.formatAmount(inv.credit_amount);
        return row;
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Summary");
      const fileName = `Invoice_Summary_${this.startDate}_to_${this.endDate}.xlsx`;
      XLSX.writeFile(workbook, fileName);
      this.showSuccessToast("Excel downloaded successfully!");
    },
  },
};
</script>


<style scoped>
.new-dispatch-modal {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #1b2a50;
  font-size: 24px;
}

.form-grid {
  display: grid;
  gap: 20px;
  width: 100%;
}

.form-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  margin-bottom: 8px;
  color: #1b2a50;
  text-align: left;
}

input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  max-width: 100%;
  box-sizing: border-box;
}

.search {
  display: flex;
  align-items: flex-end;
  color: #fff;
}

.button-default {
  margin-top: 28px;
  display: flex;
}

.download-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #007bff;
  width: 50px;
  height: 50px;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

.download-button i {
  font-size: 20px;
}

.tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: 60px;
  right: 50%;
  transform: translateX(50%);
  white-space: nowrap;
  font-size: 12px;
  z-index: 1001;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.download-button:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

input[type="checkbox"] {
  margin-right: 10px;
}

.text-center {
  text-align: center;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 20px;

  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #ddd;

  position: relative;
  z-index: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.table th,
.table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  min-width: 100px;
}

.table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
  font-weight: bold;
}

.table td:nth-child(n+3):not(:last-child) {
  text-align: left;
}

.table td:last-child,
.table td:nth-last-child(2),
.table td:nth-last-child(3) {
  text-align: left;
}

.table tr:last-child {
  font-weight: bold;
  background-color: #f1f1f1;
}

.table th,
.table td {
  padding-left: 20px;
  padding-right: 20px;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

select:focus,
select:active,
input[type="date"]:focus,
input[type="date"]:active {
  border-color: black;
  outline: none;
}

select,
input[type="date"],
.items-per-page {
  transition: border-color 0.3s ease;
}




.table th {
  position: sticky;
  top: 0;
  z-index: 10;
}

/* =========================================================
   RESPONSIVE REPORT FILTERS
========================================================= */

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: end;
  column-gap: 20px;
  row-gap: 15px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.form-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  margin-bottom: 15px;
  box-sizing: border-box;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #1b2a50;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
}

.form-group label span {
  color: #dc3545;
}

/* Remove the fixed 265px width */
.form-group select,
.form-group input[type="date"],
.form-group .search-input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 41px;
  padding: 9px 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 14px;
  box-sizing: border-box;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.form-group select:focus,
.form-group input[type="date"]:focus,
.form-group .search-input:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.form-group select:disabled,
.form-group input:disabled {
  background-color: #f5f6f8;
  color: #7a8494;
  cursor: not-allowed;
}

/* Search button alignment */
.form-group.search {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.form-group.search .button-default {
  min-width: 120px;
  height: 41px;
  margin-top: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Medium screens: two filters per row */
@media (max-width: 991px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 15px;
    row-gap: 12px;
  }

  .form-group.search {
    justify-content: flex-start;
  }

  .form-group.search .button-default {
    margin-top: 0;
  }
}

/* Mobile screens: one filter per row */
@media (max-width: 575px) {
  .new-dispatch-modal {
    padding: 14px;
  }

  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }

  .form-group {
    margin-bottom: 5px;
  }

  .form-group select,
  .form-group input[type="date"],
  .form-group .search-input {
    height: 42px;
    font-size: 14px;
  }

  .form-group.search {
    width: 100%;
  }

  .form-group.search .button-default {
    width: 100%;
    min-width: 0;
    margin-top: 4px;
  }
}
</style>
